<template>
  <div id="scale_group" class="interval-with-header">
    <div class="ef--inner">
      <ul class="scale-group-button-list">
        <li class="scale-group-button-item">
          <button class="scale-group-bt-cyan" @click="onClickBackCheck()">戻る</button>
        </li>
        <div class="scale-group-button-right">
          <ul class="scale-group-button">
            <li class="scale-group-button-item">
              <button class="scale-group-bt-cyan" @click="onClickSaveCheck()">保存</button>
            </li>
          </ul>
        </div>
      </ul>
      <li class="graph-name-list-item">
        <div class="graph-name">
          <div class="graph-name-detail"><label>グラフ名称： </label>{{ graphName }}</div>
        </div>
      </li>
    </div>
    <div class="scale-group-maincont">
      <div class="ef--inner">
        <h2>スケールグループ設定</h2>
        <div class="scale-group-list-container">
          <table class="scale-group-table" _fixedhead="rows:1;cols:0;">
            <thead>
              <tr>
                <th>№</th>
                <th>スケールグループ名称</th>
                <th>オートスケールデフォルトON</th>
                <th>固定スケール範囲</th>
                <th>単位</th>
                <th>削除</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(sg_info, index) in ScaleGroupInfo" v-bind:key="index">
                <td>{{ index + 1 }}</td>
                <td>
                  <input :id="'scale_group_name_' + index" type="text" placeholder="設定時必須項目"
                    :value="sg_info.scaleGroupName" class="scale-group-table-input-field" maxlength="20" required />
                </td>
                <td>
                  <input :id="'auto_scale_' + index" type="checkbox" :checked="sg_info.isAutoScale"
                    @click="onClickAutoScale(index)" />
                </td>
                <td>
                  <input type="number" :id="'fixed_scale_min_' + index" :value="sg_info.fixedScaleMin"
                    class="scale-group-table-input-field" placeholder="半角数字「.」「-」のみ" :readonly="sg_info.isAutoScale"
                    @input="onInputFixedScaleMin(index)" /> から
                  <input type="number" :id="'fixed_scale_max_' + index" :value="sg_info.fixedScaleMax"
                    class="scale-group-table-input-field" placeholder="半角数字「.」「-」のみ" :readonly="sg_info.isAutoScale"
                    @input="onInputFixedScaleMax(index)" />
                </td>
                <td>
                  <div class="scale-group-dropdown">
                    <select :id="'unit_' + index" :value="sg_info.unitName">
                      <option v-for="(unit, index) in UnitInfo" v-bind:key="index">{{ unit.unit_name }}</option>
                    </select>
                  </div>
                </td>
                <td><input type="checkbox" :id="'delete_flug_' + index" /></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  name: "MultiCircuitGraphScaleGroup",

  components: {
  },

  data: function () {
    return {
      graphName: "",
      ScaleGroupInfo: [],
      UnitInfo: [],
      regex: new RegExp(/e|E/),
    };
  },
  mounted: function () {
    this.getScaleInfo();
  },
  methods: {
    // スケールグループ設定情報を取得
    getScaleInfo: function () {
      const loginID = this.$store.state.loginID;
      const graphID = this.$store.state.graphID;
      var params = new Object;
      params.account = loginID;
      params.graphId = graphID;

      this.$axios
        .post(`/srv/api/multi_circuit_graph_scale_group/${loginID}`, params, {
          withCredentials: true,
        })
        .then(response => {
          this.graphName = response.data.graphName;
          this.ScaleGroupInfo = response.data.scalegroupinfo_list;
          // 20行表示させるため、空のjsonを追加
          for (let cnt = this.ScaleGroupInfo.length; cnt < 20; cnt++) {
            var emptyScaleList = new Object;
            emptyScaleList.scaleGroupId = "";
            emptyScaleList.scaleGroupName = "";
            emptyScaleList.isAutoScale = false;
            emptyScaleList.fixedScaleMin = "";
            emptyScaleList.fixedScaleMax = "";
            emptyScaleList.unitName = "";
            emptyScaleList.deleteFlug = "";
            this.ScaleGroupInfo.push(emptyScaleList);
          }
          this.UnitInfo = response.data.unit_list;
        })
        .catch(error => {
          console.error(error);
          console.error("postのAPI処理が失敗しました。");
        });

    },

    // オートスケール有効時、固定スケールをreadonly
    onClickAutoScale: function (line_index) {
      var auto_scale_check = document.getElementById(`auto_scale_${line_index}`);
      var ro_fixed_scale_min = document.getElementById(`fixed_scale_min_${line_index}`);
      var ro_fixed_scale_max = document.getElementById(`fixed_scale_max_${line_index}`);

      if (auto_scale_check.checked === true) {
        // readonly属性を設定
        ro_fixed_scale_min.readOnly = true;
        ro_fixed_scale_max.readOnly = true;
      }
      else {
        // readonly属性を削除
        ro_fixed_scale_min.readOnly = false;
        ro_fixed_scale_max.readOnly = false;
      }
    },

    // 固定スケール範囲（最小値）の最大入力値を20文字に制限
    onInputFixedScaleMin: function (line_index) {
      var ro_fixed_scale_min = document.getElementById(`fixed_scale_min_${line_index}`);

      if (ro_fixed_scale_min.value.length > 20) {
        ro_fixed_scale_min.value = ro_fixed_scale_min.value.slice(0, 20);
      }
    },

    // 固定スケール範囲（最大値）の最大入力値を20文字に制限
    onInputFixedScaleMax: function (line_index) {
      var ro_fixed_scale_max = document.getElementById(`fixed_scale_max_${line_index}`);

      if (ro_fixed_scale_max.value.length > 20) {
        ro_fixed_scale_max.value = ro_fixed_scale_max.value.slice(0, 20);
      }
    },

    // 戻るボタン押下時
    onClickBackCheck: function () {
      var ret = false;
      var changed_flug = 0;

      for (let i = 0; i < this.ScaleGroupInfo.length; i++) {
        // 入力値を取得
        var new_sg_name = document.getElementById(`scale_group_name_${i}`).value;
        var new_auto_scale = document.getElementById(`auto_scale_${i}`).checked;
        var new_fixed_scale_min = document.getElementById(`fixed_scale_min_${i}`).value;
        var new_fixed_scale_max = document.getElementById(`fixed_scale_max_${i}`).value;
        var new_unit = document.getElementById(`unit_${i}`).value;

        // 初期値と入力値を比較し、異なればフラグを有効にする
        if (new_sg_name !== this.ScaleGroupInfo[i].scaleGroupName) {
          changed_flug = 1;
          break;
        }
        if (new_auto_scale !== this.ScaleGroupInfo[i].isAutoScale) {
          changed_flug = 1;
          break;
        }
        if (new_fixed_scale_min !== this.ScaleGroupInfo[i].fixedScaleMin) {
          changed_flug = 1;
          break;
        }
        if (new_fixed_scale_max !== this.ScaleGroupInfo[i].fixedScaleMax) {
          changed_flug = 1;
          break;
        }
        if (new_unit !== this.ScaleGroupInfo[i].unitName) {
          if (this.ScaleGroupInfo[i].unitName !== null) {
            changed_flug = 1;
            break;
          }
        }
      }
      // フラグが有効の場合、ダイアログを表示
      if (changed_flug === 1) {
        if (!confirm('変更を保存せずに画面移動しますか？')) {
          return;
        }
      }
      // 画面遷移
      this.$router.push("multi_circuit_graph_maintenance");
    },

    // 保存ボタン押下時
    onClickSaveCheck: function () {
      var sgNameList = [];

      for (let i = 0; i < this.ScaleGroupInfo.length; i++) {
        // 入力値を代入
        var sg_name_value = document.getElementById(`scale_group_name_${i}`).value;
        var auto_scale_check = document.getElementById(`auto_scale_${i}`).checked;
        var fixed_scale_min_value = document.getElementById(`fixed_scale_min_${i}`).value;
        var fixed_scale_max_value = document.getElementById(`fixed_scale_max_${i}`).value;
        var unit_value = document.getElementById(`unit_${i}`).value;
        var delete_flug_check = document.getElementById(`delete_flug_${i}`).checked;

        // スケールグループ名称が未入力の場合、ダイアログを表示
        if (sg_name_value === "") {
          if (auto_scale_check === true || fixed_scale_min_value !== "" || fixed_scale_max_value !== "" || unit_value !== "" || delete_flug_check === true) {
            alert('スケールグループ名称が未入力です。');
            return;
          }
        }
        else {
          sgNameList.push(sg_name_value);

          //固定スケールの入力値が数値でない場合
          if (isNaN(fixed_scale_min_value) === true || isNaN(fixed_scale_max_value) === true) {
            alert("固定スケール範囲は以下で入力してください。\n・半角数字\n・ハイフン「-」\n・ピリオド「.」");
            return;
          }
          //固定スケールの入力値に"e"または"E"が含まれる場合
          else if (this.regex.test(fixed_scale_min_value) === true || this.regex.test(fixed_scale_max_value) === true) {
            alert("固定スケール範囲は以下で入力してください。\n・半角数字\n・ハイフン「-」\n・ピリオド「.」");
            return;
          }

          // オートスケールが無効の場合
          if (auto_scale_check === false) {
            // 固定スケール範囲が未入力の場合、ダイアログを表示
            if (fixed_scale_min_value === "" || fixed_scale_max_value === "") {
              alert('固定スケール範囲の最小値または最大値が未入力です。');
              return;
            }
            // 固定スケール範囲の最小値が最大値以上の場合、ダイアログを表示          
            else if (fixed_scale_min_value >= fixed_scale_max_value) {
              alert('固定スケール範囲の最小値は最大値未満で入力してください。');
              return;
            }
          }
        }
      }
      // スケールグループ名称が重複している場合
      if (!(sgNameList.every((v, i, self) => self.indexOf(v) === i))) {
        alert('重複したスケールグループ名称を入力できません。');
        return;
      }
      else {
        // スケールグループを作成、更新、削除する
        this.putScaleGroup();
      }
    },
    putScaleGroup: function () {
      var params = new Object;
      var multi_circuit_scaledata_change_list = [];
      var changedflg = 0;
      const loginID = this.$store.state.loginID;
      const graphID = this.$store.state.graphID;
      params.account = loginID;
      params.graphId = graphID;

      for (let cnt = 0; cnt < this.ScaleGroupInfo.length; cnt++) {
        if (document.getElementById(`scale_group_name_${cnt}`).value !== "") {
          var updateScaleDataList = new Object;
          // 入力値を代入 
          updateScaleDataList.scaleGroupId = this.ScaleGroupInfo[cnt].scaleGroupId;
          updateScaleDataList.scaleGroupName = document.getElementById(`scale_group_name_${cnt}`).value;
          updateScaleDataList.isAutoScale = document.getElementById(`auto_scale_${cnt}`).checked;
          updateScaleDataList.fixedScaleMin = document.getElementById(`fixed_scale_min_${cnt}`).value;
          updateScaleDataList.fixedScaleMax = document.getElementById(`fixed_scale_max_${cnt}`).value;

          // 固定スケール範囲の最小値と最大値における小数点以下の桁数を取得
          let fixed_scale_min_decimal = (updateScaleDataList.fixedScaleMin.split(".")[1] || "").length;
          let fixed_scale_max_decimal = (updateScaleDataList.fixedScaleMax.split(".")[1] || "").length;

          // 固定スケール範囲の最小値と最大値の桁数を比較
          if (fixed_scale_min_decimal > fixed_scale_max_decimal) {
            // 最小値の桁数に合わせるため、最大値の小数点以下をゼロ埋め
            var loop_num = fixed_scale_min_decimal - fixed_scale_max_decimal;
            if (fixed_scale_max_decimal === 0) {
              updateScaleDataList.fixedScaleMax += ".";
            }
            for (let j = 0; j < loop_num; j++) {
              updateScaleDataList.fixedScaleMax += "0";
            }
          }
          else if (fixed_scale_min_decimal < fixed_scale_max_decimal) {
            // 最大値の桁数に合わせるため、最小値の小数点以下をゼロ埋め
            loop_num = fixed_scale_max_decimal - fixed_scale_min_decimal;
            if (fixed_scale_min_decimal === 0) {
              updateScaleDataList.fixedScaleMin += ".";
            }
            for (let j = 0; j < loop_num; j++) {
              updateScaleDataList.fixedScaleMin += "0";
            }
          }
          updateScaleDataList.unitName = document.getElementById(`unit_${cnt}`).value;
          if (document.getElementById(`unit_${cnt}`).value === "") {
            updateScaleDataList.unitName = null;
          }
          updateScaleDataList.deleteFlug = document.getElementById(`delete_flug_${cnt}`).checked;
          multi_circuit_scaledata_change_list.push(updateScaleDataList);
        }
      }
      params.scalegroupinfo_list = multi_circuit_scaledata_change_list;

      this.$axios
        .put(`/srv/api/multi_circuit_graph_scale_group/${loginID}`, params, {
          withCredentials: true
        })
        .then(response => {
          const getdata = response.data;
          if (getdata.status !== undefined) {
            if (getdata.status === "success") {
              changedflg = 1;
              alert('保存しました。');
              this.reload(changedflg);
            }
            else {
              console.error("更新に失敗しました。");
            }
          }
        })
        .catch(error => {
          console.error(error);
          console.error("更新に失敗しました。");
        });
    },
    // ページリロード処理
    reload(changedflg) {
      this.$router.go({ path: this.$router.currentRoute.path, force: true });
      if (changedflg == 1) {
        this.$store.dispatch("setBeforeAct", 'update');
      }
      else if (changedflg == 2) {
        this.$store.dispatch("setBeforeAct", 'delete');
      }
      else {
        this.$store.dispatch("resetBeforeAct");
      }
    },
  }
};
</script>

<style scoped>
#scale_group h2 {
  padding-left: 15px;
  background-color: #5ca1d6;
  color: #fff;
  font-size: 18px;
  height: 45px;
  line-height: 45px;
  border-radius: 4px 4px 0 0;
}

#scale_group table {
  width: 1190px;
}

#scale_group thead tr {
  width: 100%;
  background-color: #bcd8ee;
  text-align: center;
  font-size: 13px;
  line-height: 30px;
}

#scale_group thead th {
  padding: 6px 0;
}

#scale_group tbody td {
  padding: 4px 0;
}

#scale_group tbody tr {
  width: 100%;
  background-color: #fff;
  text-align: center;
}

#scale_group tr:nth-child(2n) td {
  background-color: #f5f5f5;
}

.interval-with-header {
  padding-top: 60px;
}

.scale-group-button-list {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.scale-group-button-item {
  margin-bottom: 28px;
}

.scale-group-bt-cyan {
  display: block;
  background-color: #5ca1d6;
  border: none;
  border-radius: 4px;
  width: 120px;
  padding: 10px 20px;
  color: #fff;
  font-size: 16px;
  font-weight: normal;
  line-height: 18px;
  text-align: center;
}

.scale-group-bt-cyan:hover {
  background-color: #005cc0;
}

.scale-group-button-right {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-left: auto;
}

.scale-group-button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;

  margin-left: auto;
}

.graph-name-list-item {
  margin-right: 20px;
  margin-bottom: 15px;
}

.graph-name-list-item:last-child {
  margin-left: auto;
  margin-right: 0;
}

.graph-name-list-item .select-box {
  margin-left: 5px;
}

.graph-name {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;

  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 20px;
  padding: 10px 20px;
}

.graph-name-detail {
  margin-right: 20px;
  font-size: 16px;
}

.scale-group-maincont {
  padding-top: 10px;
}

.scale-group-list-container {
  overflow: auto;
  width: auto;
  max-height: 420px;
  margin-bottom: 20px;
}

@media screen and (max-width: 1102px) {

  .scale-group-list-container {
    width: 100%;
  }

}

.scale-group-table,
.scale-group-table td {

  border: none !important;

  outline: none !important;

}

.scale-group-table th {

  border: none !important;

  outline: none !important;
}

.scale-group-table thead {
  position: sticky;
  top: 0;
  background-color: aqua;
  z-index: 10;
}

.scale-group-table-input-field {
  background-color: #fff;
  border: 1px solid #5CA1D6;
  border-radius: 2px;
  box-sizing: border-box;
  padding-left: 3px;
  margin: 3px 0px 3px 0px;
  font-size: 12px;
  font-weight: normal;
}

.scale-group-table-input-field:read-only {
  background-color: #91a1af;
  border: 1px solid #5CA1D6;
  border-radius: 2px;
  box-sizing: border-box;
  padding-left: 3px;
  margin: 3px 0px 3px 0px;
  font-size: 12px;
  font-weight: normal;
}

.scale-group-dropdown {
  position: relative;
  display: block;
  width: 90%;
  padding: 0;
  margin-right: auto;
  margin-left: auto;
  border: 1px solid #bbb;
  border-radius: .3em;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, .04);
  background: #f3f3f3;
  /* Old browsers */
  background: -moz-linear-gradient(top, #ffffff 0%, #e5e5e5 100%);
  /* FF3.6+ */
  background: -webkit-linear-gradient(top, #ffffff 0%, #e5e5e5 100%);
  /* Chrome10+,Safari5.1+ */
  background: -o-linear-gradient(top, #ffffff 0%, #e5e5e5 100%);
  /* Opera 11.10+ */
  background: -ms-linear-gradient(top, #ffffff 0%, #e5e5e5 100%);
  /* IE10+ */
  background: linear-gradient(to bottom, #ffffff 0%, #e5e5e5 100%);
  /* W3C */
}

/* This is the native select, we're making everything the text invisible so we can see the button styles in the wrapper */
.scale-group-dropdown select {
  width: 100%;
  background: none;
  appearance: none;
  -webkit-appearance: none;
  font-size: 0.75em;
  color: #444;
  padding: 0.3em 1.9em 0em 0.5em;
  line-height: 1.3;
}

.scale-group-dropdown::after {
  content: "";
  position: absolute;
  width: 9px;
  height: 8px;
  top: 50%;
  right: 0.5em;
  margin-top: -4px;
  z-index: 2;
  background: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 12'%3E%3Cpolygon fill='rgb(102,102,102)' points='8,12 0,0 16,0'/%3E%3C/svg%3E") 0 0 no-repeat;
  /* These hacks make the select behind the arrow clickable in some browsers */
  pointer-events: none;
}

/* Hover style */
.scale-group-dropdown:hover {
  border: 1px solid #888;
}
</style>